import { render, staticRenderFns } from "./EditDashboard.vue?vue&type=template&id=50eeaf66&scoped=true"
import script from "./EditDashboard.vue?vue&type=script&lang=js"
export * from "./EditDashboard.vue?vue&type=script&lang=js"
import style0 from "./EditDashboard.vue?vue&type=style&index=0&id=50eeaf66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eeaf66",
  null
  
)

export default component.exports